module.exports = __webpack_public_path__ + "img/search.4a1b8852.svg";